export enum ELoadingStatus {
  Loading = 'loading',
  Success = 'success',
  Failure = 'failure',
}
